var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m8.97 1.5 1.488.5c1.983 0 1.487 2 1.487 2H.055S-.44 2 1.542 2l1.488-.5V0h5.94zM4.021 1H7.98v1H4.02zM11 12.5c-.047 0-.047 1.5-1.5 1.5h-7c-1.453 0-1.453-1.5-1.5-1.5V5h10zM5.03 12V7h-1v5zm2.949 0V7h-1v5z"
})));
export default SvgDelete;